import { Component } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ReportesRepository } from 'src/app/repositorio/reportes.repository';
import { UtilService, optionExcelExport } from 'src/app/services/util.service';
import { newmetadate } from 'src/app/shared/components/datatable/domain/datatable-domain';
import { SharedModule } from 'src/app/shared/shared.module';
import { kunaqRequest } from '../../domain/kunaq.request';
import { catchError, map, of } from 'rxjs';
import { ParametrosKunaqDTO } from '../../domain/kunaq.response';

@Component({
    selector: 'app-bandeja-kunaq',
    standalone: true,
    imports: [SharedModule],
    templateUrl: './bandeja-kunaq.component.html',
    styleUrl: './bandeja-kunaq.component.css'
})
export class BandejaKunaqComponent {

  constructor(
    private readonly util: UtilService,
    private readonly servReporte: ReportesRepository
  ) { }

  ngOnInit(): void {
    this.ngOnInitForm()
    this.changeParameters()
  }

  group: FormGroup
  ngOnInitForm() {
    const hoy = new Date()
    const primero = new Date(hoy.getFullYear(), hoy.getMonth(), 1)
    const ultimo = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0)
    this.group = new FormGroup({
      desde: new FormControl(primero, null),
      hasta: new FormControl(ultimo, null),
      tipo: new FormControl("1", null),
      importador: new FormControl(null, null)
    })
  }

  listaCliente: ParametrosKunaqDTO[] = []
  changeParameters() {
    this.servReporte.ParametrosKunaq().subscribe(response => {
      if (response.datos.status === 200) {
        this.listaCliente = response.datos.result
      }
    })
  }

  datatable: any[] = []
  metadatatable: newmetadate[] = [
    { field: "razonSocialImportador", title: "Razon Social Importador", inputType: "text", style: { justify: "left" } },
    { field: "agenteCargaDestino", title: "Agente Carga Destino", inputType: "text", style: { justify: "left" } },
    { field: "nombrePaisEmbarque", title: "Pais Origen", inputType: "text", style: { justify: "left" } },
    { field: "nombrePuertoEmbarque", title: "Puerto Origen", inputType: "text", style: { justify: "left" } },
    { field: "teus", title: "Teus", inputType: "text" }
  ]

  ngChangeTypeReport() {
    this.datatable = []
    if (parseInt(this.group.value.tipo) == 1) {
      this.metadatatable = [
        { field: "razonSocialImportador", title: "Razon Social Importador", inputType: "text", style: { justify: "left" } },
        { field: "agenteCargaDestino", title: "Agente Carga Destino", inputType: "text", style: { justify: "left" } },
        { field: "nombrePaisEmbarque", title: "Pais Origen", inputType: "text", style: { justify: "left" } },
        { field: "nombrePuertoEmbarque", title: "Puerto Origen", inputType: "text", style: { justify: "left" } },
        { field: "teus", title: "Teus", inputType: "text" }
      ]
    } else {
      this.metadatatable = [
        { field: "cliente", title: "Razon Social Importador", inputType: "text", style: { justify: "left" } },
        { field: "vendedor", title: "Ejecutivo Ventas", inputType: "text", style: { justify: "left" } },
        { field: "origen", title: "Puerto Origen", inputType: "text", style: { justify: "left" } },
        { field: "destino", title: "Puerto Destino", inputType: "text", style: { justify: "left" } },
        { field: "teus", title: "Teus", inputType: "text" }
      ]
    }
  }

  async search() {
    const request = <kunaqRequest>{}
    request.fechallegadadesde = this.group.value.desde
    request.fechallegadahasta = this.group.value.hasta
    request.tipo = parseInt(this.group.value.tipo)
    request.importador = this.group.value.importador && this.group.value.importador.length > 0
      ? this.group.value.importador.map(r => {
        return {
          filt_codigoint: 0,
          filt_codigovar: "",
          filt_nombre: r
        };
      })
      : []

    if (parseInt(this.group.value.tipo) === 1) {
      this.datatable = []
      const loading = this.util.showLoadingScreen({ message: "Consultando Información" })
      try {
        const response = await this.servReporte.InfoKunaq(request).toPromise()
        if (response.datos.status = 200) {
          this.datatable = response.datos.result;
          loading.close()
        }
      } catch (error) {
        console.error('Error en la búsqueda', error);
        loading.close()
        this.util.ShowMessage({ mensaje: "Hubo un error al consultar la información.", tipo: "warning" })
      }

      // this.servReporte.InfoKunaq(request).pipe(
      //   map(response => {
      //     this.datatable = response.datos.result;
      //     loading.close()
      //   }),
      //   catchError(error => {
      //     // Manejo de errores, si es necesario
      //     console.error('Error en la búsqueda', error);
      //     loading.close()
      //     this.util.ShowMessage({ mensaje: "Hubo un error al consultar la información.", tipo: "warning" })
      //     return of([]); // Retorna un observable vacío en caso de error
      //   })
      // ).subscribe();  // Recuerda suscribirte al observable
    } else {

      this.datatable = []
      const loading2 = this.util.showLoadingScreen({ message: "Consultando Información" })
      try {
        const response = await this.servReporte.InfoRporteGerencial(request).toPromise()
        if (response.datos.status = 200) {
          this.datatable = response.datos.result;
          loading2.close()
        }
      } catch (error) {
        console.error('Error en la búsqueda', error);
        loading2.close()
        this.util.ShowMessage({ mensaje: "Hubo un error al consultar la información.", tipo: "warning" })
      }
    }
  }

  export() {
    const option: optionExcelExport = {
      fileName: parseInt(this.group.value.tipo) === 1 ? "Info Kunaq" : "Reporte Gerencial - ETA",
      sheets: [
        {
          data: this.datatable.map(r => {
            return Object.keys(r).reduce((acc, key) => {
              // Convertimos cada clave a mayúsculas
              acc[key.toUpperCase()] = r[key];
              return acc;
            }, {});
          }),
          sheetName: "Datos"
        }],
      typeFile: '.xlsx'
    }
    this.util.ExportExcel(option)
  }

  async syncKunaq() {
    const loading = this.util.showLoadingScreen({ message: "Sincronizando." })
    try {
      const response = await this.servReporte.syncKunaq().toPromise()
      loading.close()
    } catch {
      loading.close()
      this.util.ShowMessage({ mensaje: "No se pudo sincronizar, consulte a su administrador.", tipo: "warning" })
    }

  }

}
